import { CalibrationDisplaySchema } from "../types";

/**
 * Laser Distance (Range) calibration display schema.
 *
 * Calibrations are submitted by NexaWave Device Setup / laser utility after
 * three AT+LASERDIST? points. No manual input form — inputFieldConfig omitted.
 *
 * API, storage, details page, and certificate all use millimetres.
 */
export const LaserRangeSchema: CalibrationDisplaySchema = {
  sensorType: "laser-node",
  unit: "mm",

  certificateFormConfig: {
    title: "Laser Range Certificate Details",
    fields: [
      {
        key: "date",
        label: "Date",
        type: "date",
        placeholder: "DD.MM.YYYY",
      },
      {
        key: "temperature",
        label: "Ambient Temperature",
        type: "text",
        placeholder: "e.g., 26 °C",
        unit: "°C",
      },
    ],
  },

  inputData: {
    sections: [
      {
        title: "Test Configuration",
        bgColor: "bg-blue-50",
        group: "setup",
        fields: [
          { key: "range_variant", label: "Range Variant", unit: "" },
          { key: "firmware_version", label: "Firmware Version", unit: "" },
          { key: "serial_id", label: "Confirmed Serial", unit: "" },
          { key: "ambient_temperature", label: "Ambient Temperature", unit: "°C" },
          { key: "humidity", label: "Humidity", unit: "%" },
        ],
      },
    ],

    tables: [
      {
        title: "Distance Test Points (raw)",
        bgColor: "bg-green-50",
        group: "measurement",
        dataKey: "test_results",
        columns: [
          { key: "point", label: "Point", unit: "" },
          {
            key: "true_distance_mm",
            label: "True Distance",
            unit: "mm",
            className: "font-mono",
          },
          {
            key: "measured_raw_mm",
            label: "Measured (raw)",
            unit: "mm",
            className: "font-mono",
          },
        ],
      },
    ],
  },

  outputData: {
    sections: [
      {
        title: "Summary",
        bgColor: "bg-green-50",
        group: "result",
        fields: [
          { key: "calibration_status", label: "Calibration Status", unit: "" },
          { key: "device_name", label: "Item", unit: "" },
          { key: "model", label: "Model", unit: "" },
          { key: "range_variant", label: "Range Variant", unit: "" },
          {
            key: "measurement_range",
            label: "Measurement Range",
            unit: "mm",
          },
          {
            key: "max_error_mm",
            label: "Max Error",
            unit: "mm",
          },
          {
            key: "ambient_temperature",
            label: "Ambient Temperature",
            unit: "°C",
          },
          { key: "humidity", label: "Humidity", unit: "%" },
          { key: "serial_id", label: "Serial ID", unit: "" },
          { key: "firmware_version", label: "Firmware Version", unit: "" },
        ],
      },
    ],

    tables: [
      {
        title: "Distance Test Results (computed)",
        bgColor: "bg-blue-50",
        group: "analysis",
        dataKey: "test_results",
        columns: [
          { key: "point", label: "Point", unit: "" },
          {
            key: "true_distance_mm",
            label: "True",
            unit: "mm",
            className: "font-mono",
          },
          {
            key: "measured_mm",
            label: "Measured",
            unit: "mm",
            className: "font-mono",
          },
          {
            key: "error_mm",
            label: "Error",
            unit: "mm",
            className: "font-mono",
          },
          { key: "pass_fail", label: "Result", unit: "" },
        ],
        rowClassName: (row) =>
          String(row?.pass_fail || "").toLowerCase() === "fail"
            ? "bg-red-50"
            : "",
      },
    ],
  },
};
